/**
 * Contrôles de format communs aux formulaires (mêmes règles que le serveur).
 */

/** Téléphone : chiffres, espaces, « + », « - », « . », parenthèses ; 8 à 15 chiffres. */
export function telephoneValide(t) {
  const v = String(t || '').trim()
  if (!v) return true
  if (!/^\+?[0-9 .\-()]+$/.test(v)) return false
  const n = v.replace(/\D/g, '').length
  return n >= 8 && n <= 15
}

export function emailValide(e) {
  const v = String(e || '').trim()
  return !v || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)
}

export const MESSAGE_TELEPHONE = 'Numéro invalide : chiffres uniquement, 8 à 15 chiffres (ex. +223 70 00 00 00).'
export const MESSAGE_EMAIL = 'Adresse e-mail invalide (ex. nom@domaine.com).'
